import Carousel from "../classes/carousel";
import MultiCarousel from "../classes/multi_carousel";
import ThumbnailCarousel from "../classes/thumbnail_carousel";

export default class CarouselInitializer {
  constructor(scope) {
    this.scope = scope;
    this.initialize();
  }

  initialize() {
    const generalCarousels = this.scope.querySelectorAll("[data-js='carousel-general']");
    if (generalCarousels) {
      const generalOptions = {
        slidesPerView: "auto",
        spaceBetween: 20,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      };

      generalCarousels.forEach((generalCarousel) => {
        new Carousel(generalCarousel, generalOptions);
      });
    }

    const newsCarousels = this.scope.querySelectorAll("[data-js='carousel-news']");
    if (newsCarousels) {
      const newsOptions = {
        slidesPerView: "auto",
        spaceBetween: 20,
      };

      newsCarousels.forEach((newsCarousel) => {
        new Carousel(newsCarousel, newsOptions);
      });
    }

    const employeeCarousels = this.scope.querySelectorAll("[data-js='carousel-employee']");
    if (employeeCarousels) {
      const employeeOptions = {
        slidesPerView: "auto",
        spaceBetween: 20,
      };

      employeeCarousels.forEach((employeeCarousel) => {
        new Carousel(employeeCarousel, employeeOptions);
      });
    }

    const productCarousels = this.scope.querySelectorAll("[data-js='carousel-product']");
    if (productCarousels) {
      const productOptions = {
        breakpoints: {
          0: {
            slidesPerView: "auto",
            spaceBetween: 20,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
        },
      };

      productCarousels.forEach((productCarousel) => {
        new Carousel(productCarousel, productOptions);
      });
    }

    const eLearningCarousels = this.scope.querySelectorAll("[data-js='carousel-e-learning']");
    if (eLearningCarousels) {
      const eLearningOptions = {
        breakpoints: {
          0: {
            slidesPerView: "auto",
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
        },
      };

      eLearningCarousels.forEach((eLearningCarousel) => {
        new Carousel(eLearningCarousel, eLearningOptions);
      });
    }

    const tripleCardCarousels = this.scope.querySelectorAll("[data-js='carousel-triple-card']");
    if (tripleCardCarousels) {
      const tripleCardOptions = {
        breakpoints: {
          0: {
            slidesPerView: "auto",
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
        },
      };

      tripleCardCarousels.forEach((tripleCardCarousel) => {
        new Carousel(tripleCardCarousel, tripleCardOptions);
      });
    }

    const mediaCarousels = this.scope.querySelectorAll("[data-js='carousel-media']");
    if (mediaCarousels) {
      const mediaOptions = {
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: "auto",
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      };

      mediaCarousels.forEach((mediaCarousel) => {
        new Carousel(mediaCarousel, mediaOptions);
      });
    }

    const multiDistributorsCarousels = this.scope.querySelectorAll("[data-js='multi-carousel-distributors']");
    if (multiDistributorsCarousels) {
      const multiDistributorsFirstOptions = {
        initialSlide: 0,
      };

      const multiDistributorsSecondOptions = {
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      };

      multiDistributorsCarousels.forEach((multiDistributorsCarousel) => {
        new MultiCarousel(multiDistributorsCarousel, multiDistributorsFirstOptions, multiDistributorsSecondOptions);
      });
    }

    const historyCarousels = this.scope.querySelectorAll("[data-js='carousel-history']");
    if (historyCarousels) {
      const historyOptions = {
        loop: true,
        slidesPerView: 1,
      };

      historyCarousels.forEach((historyCarousel) => {
        new Carousel(historyCarousel, historyOptions);
      });
    }

    const thumbnailProductCarousels = this.scope.querySelectorAll("[data-js='thumbnail-carousel-product']");
    if (thumbnailProductCarousels) {
      const thumbnailProductOptions = {
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
      };
      const thumbnailProductThumbnailOptions = {
        slidesPerView: 4,
        watchSlidesProgress: true,
      };

      thumbnailProductCarousels.forEach((thumbnailProductCarousel) => {
        new ThumbnailCarousel(thumbnailProductCarousel, thumbnailProductOptions, thumbnailProductThumbnailOptions);
      });
    }

    const tabsCarousels = this.scope.querySelectorAll("[data-js='tabs-carousel']");
    if (tabsCarousels) {
      let tabsCarouselOptions = {
        autoHeight: true,
        paginationClickable: true,
        pagination: {
          clickable: true,
        },
      };

      tabsCarousels.forEach((tabsCarousel) => {
        const tabsLabelArray = tabsCarousel.dataset.tabsLabel.split(",");

        if (tabsCarousel.dataset.showIcons) {
          tabsCarouselOptions.pagination.renderBullet = (index, className) => {
            return `<div data-name="${tabsLabelArray[index]}" class="tab-wrapper flex-grow-1 color-${tabsLabelArray[index]} ${className}"><div class="tab"><i class="icon icon-${tabsLabelArray[index]}"></i></div></div>`;
          };
        } else {
          tabsCarouselOptions.pagination.renderBullet = (index, className) => {
            return `<div data-name="${tabsLabelArray[index]}" class="tab-wrapper flex-grow-1 color-primary ${className}"><div class="tab">${tabsLabelArray[index]}</div></div>`;
          };
        }

        const paginationElement = tabsCarousel.querySelector(".js-tabs-swiper");
        tabsCarouselOptions.pagination.el = paginationElement;

        new Carousel(tabsCarousel, tabsCarouselOptions);
      });
    }

    const productBundleCarousels = this.scope.querySelectorAll("[data-js='carousel-product-bundle']");
    if (productBundleCarousels) {
      const productBundleOptions = {
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          576: {
            slidesPerView: 1,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 24,
          },
        },
        on: {
          beforeTransitionStart: (swiper) => {
            swiper.el.classList.add("is-sliding");
          },
          sliderFirstMove: (swiper) => {
            swiper.el.classList.add("is-sliding");
          },
          transitionEnd: (swiper) => {
            swiper.el.classList.remove("is-sliding");
          },
        },
      };

      productBundleCarousels.forEach((productBundleCarousel) => {
        new Carousel(productBundleCarousel, productBundleOptions);
      });
    }
  }
}

new CarouselInitializer(document.body); // To initialize carousels on page load
